var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71364 19.8301C7.03903 14.1412 7.54435 7.45331 7.54435 7.45331C7.54435 7.45331 8.48522 7.43651 9.50115 7.34512C10.5557 7.24977 11.5039 6.97804 11.5039 6.97804C11.5039 6.97804 11.2375 13.0785 12.6472 19.2471C13.9333 24.8703 15.9197 26.7496 15.9197 26.7487C15.9186 26.7496 12.1514 25.0165 9.71364 19.8301ZM27.9458 5.30768C27.9458 5.30768 24.417 5.77949 21.4908 5.2474C18.8294 4.76374 16.0021 2.99803 16.0005 3C15.9973 2.99803 13.171 4.76374 10.5091 5.2474C7.58341 5.77949 4.05409 5.30768 4.05409 5.30768C4.05409 5.30768 3.33416 15.1006 7.14733 21.3725C10.6243 27.0895 15.9984 29.0005 16.0005 29C16.0015 29.0005 21.3751 27.0895 24.8521 21.3725C28.6663 15.1006 27.9458 5.30768 27.9458 5.30768Z",
    fill: "#747486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.3cace92b73939ba02a754233e080040e.svg";
export { ForwardRef as ReactComponent };